import { defineStore } from "pinia";
import { ref } from "vue";

export const useRestartNotificationStore = defineStore("restartNotification", () => {
	const emergencySave = ref(false);

	return {
		emergencySave,
	};
});
